import {useCallback, useEffect, useState} from 'react'
import {payoutApiGet} from './api'
import {PayoutDetailResponse} from './types'

export const usePayoutDetailData = (platformId?: string | number, payoutDate?: string) => {
  const [data, setData] = useState<PayoutDetailResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchData = useCallback(async () => {
    if (!platformId || !payoutDate) return

    setLoading(true)
    setError(null)
    try {
      const response: any = await payoutApiGet<PayoutDetailResponse>(
        `/api/platform-order-payout-details/${platformId}/${encodeURIComponent(payoutDate)}`
      )
      setData(response?.data || response)
    } catch (err: any) {
      setError(err?.response?.data?.detail || err?.message || 'Failed to fetch payout details')
      setData(null)
    } finally {
      setLoading(false)
    }
  }, [platformId, payoutDate])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {data, loading, error, refetch: fetchData}
}
